<template>
    <div class="mainBox">
      <div class="containerBox">
        <div class="pBox">
          <div class="title">
            <h3>本纪念馆为非公开纪念馆</h3> 
          </div>
          <div class="pwdText">
            请输入纪念馆密码
          </div>
          <br />
          <van-field  v-model="form.pwd" placeholder="请输入访问密码" />
          <br />
        </div>
        <div class="bottom">
          <van-button @click="onGoHome" type="info">返回首页</van-button>
          <van-button @click="MemorialHallValidate" type="danger">确认进入</van-button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Toast } from "vant";
  
  export default {
    data() {
      return {
        form:{
          type:"MemorialHallValidate",
          id:"",
          pwd:""
        }
      };
    },
    methods:{
  
      MemorialHallValidate(){
        console.log(this.form)
        if(this.form.id==""||this.form.id==undefined)
        {
          Toast("没有找到相应纪念馆！");
          return false;
        }
        if(this.form.pwd=="")
        {
          Toast("访问密码不能为空！");
          return false;
        }
        this.$store.dispatch(this.form).then(res=>{
          Toast(res.Message);
          if(res.IsSuccess)
          {
            sessionStorage.setItem(this.form.id,true);
            this.$router.replace("/MemorialHall?id="+res.Information)
          }
        })
      },
      onGoHome(){
        this.$router.replace("/")
      }
    },
    created(){
      this.form.id=this.$route.query.id;
  
  
    }
  
  };
  </script>
  
  <style scoped lang="less">
  .mainBox {
    position: absolute;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("~@/assets/images/private.jpg");
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    // flex-direction: column;
    .pBox {
      .title{
        padding: 5px;
      }
  
      
    }
    .bottom {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
    }
  }
  </style>
  